/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface ToolbarToggleArgs {
  icon?: string;
  label?: string;
  isActive?: boolean;
  onClick: () => unknown;
}

export default class ToolbarToggle extends Component<ToolbarToggleArgs> {}
